/**
 *  FreshChat 聊天
 * SDK操作文档: https://developers.freshchat.com/web-sdk/#setup
 * 将 FreshChat 模块抽离出来，对需要使用到的地方按需加载
 */

const token = 'efd25117-0308-461b-9222-32fe62e48c8d'
const host = 'https://kilimall.freshchat.com'
const loadFreshchatURL = 'https://kilimall.freshchat.com/js/widget.js'
const freshchatTagId = 'freshchat-js-sdk'

function initFreshChat(hideChatButton: boolean = true) {
  window.fcWidget.init({
    token,
    host,
    config: {
      headerProperty: {
        // 隐藏默认聊天按钮
        hideChatButton
      }
    },
    tags: ['lite']
  })

  // window.fcWidget.setExternalId('john.doe1987')

  // To set user name
  window.fcWidget.user.setFirstName('Unknown user')

  // To set user email
  // window.fcWidget.user.setEmail('john.doe@gmail.com')

  // To set user properties
  window.fcWidget.user.setProperties({
    plan: 'Estate', // meta property 1
    status: 'Active' // meta property 2
  })
}

/**
 * 初始化 聊天组件
 * @param {*} doc document对象
 * @returns
 */
function initializeFreshChat(doc: any, hideChatButton: boolean = true) {
  const tag = doc.getElementById(freshchatTagId)
  return new Promise((resolve) => {
    // 如果 freshChat JS-SDK 已加载，则只需要初始化 聊天组件
    if (tag) {
      resolve(initFreshChat(hideChatButton))
    } else {
      const scriptEl = doc.createElement('script')
      scriptEl.id = freshchatTagId
      scriptEl.src = loadFreshchatURL
      doc.head.appendChild(scriptEl)

      scriptEl.onload = () => {
        initFreshChat(hideChatButton)
        resolve({})
      }
    }
  })
}

let interval: any
let currentSleepTime = 0
const maxSleepTime = 60 * 2 * 100
async function fcWidgetOpen() {
  if (interval) {
    return
  }
  await initializeFreshChat(document)
  return new Promise((resolve, reject) => {
    interval = setInterval(() => {
      currentSleepTime += 1
      const isLoaded = window.fcWidget.isLoaded()

      if (currentSleepTime >= maxSleepTime || isLoaded) {
        clearInterval(interval)
        interval = null

        const err = { msg: 'fresh-chat 组件加载失败!' }
        if (isLoaded) {
          window.fcWidget.open()
          resolve({})
        } else {
          reject(err)
        }
      }
    }, 15)
  })
}

export default defineNuxtPlugin((NuxtApp) => {
  return {
    provide: {
      initializeFreshChat,
      fcWidgetOpen
    }
  }
})
